import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { UsersContent } from "@/features/dashboard/usuarios/components/UsersContent";

export const Route = createFileRoute("/_private/dashboard/_base/usuarios/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar Usuário" from="/dashboard/usuarios/editar">
      <UsersContent />
    </BaseEditCreateModal>
  );
}
